import { branch, compose, renderNothing } from 'recompose';
import { canUserViewWaitingList } from '../../../../../common/helpers/users';
import OldWalkInListButton from '../components/OldWalkInListButton';
import withPermissions from '../../../../../auth/utils/withPermissions';
import { flagNames, withInjectFeatureFlagsToProps } from '../../../../../../modules/infra/feature-flags';
import { getActiveShop, isBarberUser } from '../../../../../auth/selectors';
import { connect } from 'react-redux';
import withToggle from '../../../../../common/hoc/withToggle';
import { WalkInList } from '../../../../../../modules/shared/appointments/walk-in-list';

const OldWalkInListButtonContainer = compose(
  withInjectFeatureFlagsToProps([flagNames.WALK_IN_LIST]),
  withPermissions,
  withToggle('oldWalkInListOpen', false),
  connect((state) => ({
    shop: getActiveShop(state),
    isBarberUser: isBarberUser(state),
  })),
  branch(
    props => {
      // Always hide the old walk-in button - replaced by new implementation
      return true;
    },
    renderNothing
  ),
)(({ oldWalkInListOpenIsOn, oldWalkInListOpenOn, oldWalkInListOpenOff, ...props }) => (
  <>
    <OldWalkInListButton onClick={oldWalkInListOpenOn} />
    {oldWalkInListOpenIsOn && <WalkInList onClose={oldWalkInListOpenOff} />}
  </>
));

export default OldWalkInListButtonContainer; 